const Jurisdictions = {
    'default' : 'Default',
    'al' : 'Alabama',
    'ak' : 'Alaska',
    'ar' : 'Arkansas',
    'az' : 'Arizona',
    'ca' : 'California',
    'ct' : 'Conneticut',
    'co' : 'Colorado',
    'de' : 'Deleware',
    'fl' : 'Florida',
    'hi' : 'Hawaii',
    'id' : 'Idaho',
    'il' : 'Illinois',
    'in' : 'Indiana',
    'ia' : 'Iowa',
    'ka' : 'Kansas',
    'ky' : 'Kentucky',
    'la' : 'Louisiana',
    'me' : 'Maine',
    'md' : 'Maryland',
};

export default Jurisdictions;